module.exports = __webpack_public_path__ + "img/download.209018ba.svg";